import { ChevronRight } from 'lucide-react'

import { useGetQuotingProspectsProspectIdCensusId } from 'utils/web_api'

import { CensusUploaded } from './CensusBanners'
import { GettingCensusFailed } from './GetErrorBanners'
import ProspectCensusDetails from './ProspectCensusDetails'
import { QuoteCreateCensusUpload } from './QuoteCreateCensusUpload'
import { type GrapeAPIErrorType } from '../hooks/GrapeAPIError'

// This is the page that is shown for the quotes that are being created
// and have the census upload steps started.
// If census is being processed or has been processed,
// it will show the census details.
// If the census upload has failed, it will show the census upload form
// to allow the user to re-upload the census file.
export function QuoteCreateCensusDetails ({
  prospectId,
  quoteId,
  censusId,
  onCensusUploadDone,
}: {
  prospectId: string;
  quoteId: string;
  censusId: string;
  onCensusUploadDone: () => void;
}) {
  const { data, error, isLoading } = useGetQuotingProspectsProspectIdCensusId(
    prospectId,
    censusId,
    {
      query: {
        enabled: !!censusId,
        retry: false,
        refetchInterval: (query) => {
          if (['processed', 'failed'].includes(query.state.data?.status ?? '')) {
            return false
          }
          return 1000
        },
      }
    }
  )

  if (isLoading && !data) {
    return <div>Loading...</div>
  } else if (!isLoading && error) {
    return <GettingCensusFailed errorObj={error as GrapeAPIErrorType} />
  } else if (!isLoading && !error && !data) {
    return <div>Census not found</div>
  } else if (!isLoading && !error && data) {
    return (
      <>
        <div className='flex flex-col space-y-10'>
          {data.status === 'processed' && <CensusUploaded />}
          {data.status !== 'failed' && (
            <ProspectCensusDetails
              census={data}
              censusId={censusId}
              prospectId={prospectId}
            />
          )}
          {data.status === 'failed' && (
            <QuoteCreateCensusUpload
              prospectId={prospectId}
              quoteId={quoteId}
              census={data}
            />
          )}
        </div>
        {data.status === 'processed' && (
          <div className='flex'>
            <button
              className='btn-primary'
              type='button'
              onClick={onCensusUploadDone}
            >
              Next
              <ChevronRight size={16} className='ml-1' />
            </button>
          </div>
        )}
      </>
    )
  } else {
    // should not go to this state
    return null
  }
}
